import React from "react";
import styled from "styled-components";
import { colors } from "src/styles";

type AssetGeneralData = {
  stationName: string;
  title: string;
  status: string;
  stationAddress: string;
  assetId: string;
  category: string;
  roomLocation: string;
  manufacturer: string;
  model: string;
  serialNumber: string;
  yearInstalled: string;
  capacity: string;
  materialType: string;
  equipmentTag: string;
  dimensionalInfo: string;
};

interface GeneralInformationProps {
  data: AssetGeneralData;
}

const GeneralInformation: React.FC<GeneralInformationProps> = ({ data }) => {
  return (
    <PageLayout>
      <MainContent>
        <TitleRow>
          <AssetTitle>
            {data.stationName}: {data.title}
          </AssetTitle>
          <StatusBadge status={data.status}>{data.status}</StatusBadge>
        </TitleRow>

        <InfoGrid>
          <InfoCol>
            <InfoItem>
              <InfoLabel>Station Name</InfoLabel>
              <InfoValue>{data.stationName}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Station Address</InfoLabel>
              <InfoValue>{data.stationAddress}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Asset ID</InfoLabel>
              <InfoValue>{data.assetId}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Asset Name</InfoLabel>
              <InfoValue>{data.title}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Category</InfoLabel>
              <InfoValue>{data.category}</InfoValue>
            </InfoItem>
          </InfoCol>
          <InfoCol>
            <InfoItem>
              <InfoLabel>Room / Location</InfoLabel>
              <InfoValue>{data.roomLocation}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Manufacturer</InfoLabel>
              <InfoValue>{data.manufacturer}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Model</InfoLabel>
              <InfoValue>{data.model}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Serial Number</InfoLabel>
              <InfoValue>{data.serialNumber}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Year Installed</InfoLabel>
              <InfoValue>{data.yearInstalled}</InfoValue>
            </InfoItem>
          </InfoCol>
        </InfoGrid>

        <Divider />

        <InfoGrid>
          <InfoCol>
            <InfoItem>
              <InfoLabel>Manufacturer</InfoLabel>
              <InfoValue>{data.manufacturer}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Model</InfoLabel>
              <InfoValue>{data.model}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Serial Number</InfoLabel>
              <InfoValue>{data.serialNumber}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Year Installed</InfoLabel>
              <InfoValue>{data.yearInstalled}</InfoValue>
            </InfoItem>
          </InfoCol>
          <InfoCol>
            <InfoItem>
              <InfoLabel>Capacity</InfoLabel>
              <InfoValue>{data.capacity}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Material Type</InfoLabel>
              <InfoValue>{data.materialType}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Equipment Tag</InfoLabel>
              <InfoValue>{data.equipmentTag}</InfoValue>
            </InfoItem>
            <InfoItem>
              <InfoLabel>Dimensional Information</InfoLabel>
              <InfoValue>{data.dimensionalInfo}</InfoValue>
            </InfoItem>
          </InfoCol>
        </InfoGrid>

        <Divider />
      </MainContent>
    </PageLayout>
  );
};

const PageLayout = styled.div`
  //   display: grid;
  //   grid-template-columns: 1fr 240px;
  gap: 24px;
  align-items: start;
`;

const MainContent = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 24px 28px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const AssetTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

const StatusBadge = styled.span<{ status: string }>`
  background: ${({ status }: { status: string }) => (status === "ACTIVE" ? "#3a7d3a" : "#d32f2f")};
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 14px;
  border-radius: 4px;
  letter-spacing: 0.5px;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 32px;
`;

const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const InfoItem = styled.div`
  display: grid;
  grid-template-columns: 150px 1fr;
  gap: 8px;
  align-items: baseline;
`;

const InfoLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.grey.dark};
`;

const InfoValue = styled.span`
  font-weight: 400;
  font-size: 14px;
  font-style: unset;
  color: unset;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 20px 0;
`;

export default GeneralInformation;
